import { render, staticRenderFns } from "./MVMInfo.vue?vue&type=template&id=7ad1c9bc&"
import script from "./MVMInfo.vue?vue&type=script&lang=js&"
export * from "./MVMInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports